import React from "react";
import { Component } from "react";
import { slide as Menu } from "react-burger-menu";
import SlideToggle from 'react-slide-toggle';
import InputRange from 'react-input-range';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from 'react-router-dom';
import { getAllFilters} from '../../actions/filters';
import SimpleReactValidator from 'simple-react-validator';
import { getCSAProductList, sendCsaProductSearchValue } from "../../actions/csaApp";
const mobileToggleMenu = ({ isOpen })=> {
    const menuWrap = document.querySelector(".bm-menu-wrap");
  if(isOpen){
    menuWrap.style.margin = "100px 0px 0px 0px"
     menuWrap.setAttribute("aria-hidden", false) 
     menuWrap.style.position="fixed"
     menuWrap.style.right="0px"
     menuWrap.style.display='block'
    }else{
    menuWrap.setAttribute("aria-hidden", true)
    menuWrap.style.position="fixed"
    menuWrap.style.right="0px"
    menuWrap.style.display='none'
}
}
const toggleMenu = ({ isOpen }) => {
  const menuWrap = document.querySelector(".bm-menu-wrap");
  if(isOpen){
     menuWrap.setAttribute("aria-hidden", false) 
     menuWrap.style.position="absolute"
     menuWrap.style.right="50px"
     menuWrap.style.display='block'
    }else{
    menuWrap.setAttribute("aria-hidden", true)
    menuWrap.style.position="fixed"
    menuWrap.style.right="0px"
    menuWrap.style.display='none'
}
};
class BurgerMenu extends Component {
    constructor() {
        super();
        this.state = {
            openFilter: false,
            toggleBrand:true,
        toggleCategory : true,
        toggleSize : true,
        toggleColor : true,
        toggleRange : true,
        filterStoreFlag: 'TS',
            selectedBrands: [],
            selectedSizes: [],
            selectedColors: [],
            selectedCategories:[],
            selectedGenders: [],
            value: { min: 0, max: 999999 },
            brandError:'',
            categoryError:'',
               genderError: '',
      matches: window.matchMedia("(max-width: 768px)").matches
        }
        this.validator = new SimpleReactValidator();
    }
    handleToggle (){
        this.setState({
           toggleBrand: true,
           toggleCategory : false,
           toggleGender : false,
           toggleSize : false,
           toggleColor : false,
           toggleRange : false,
        })
        localStorage.removeItem('category_name')
        var elmnt = document.getElementById("collection-filter-block");
      elmnt.scrollTop =150;
       //localStorage.setItem('toggleCat',true)
   }
   handleGenderToggle (){
    this.setState({
        toggleGender:true,
       toggleBrand: false,
       toggleCategory : false,
       toggleSize : false,
       toggleColor : false,
       toggleRange : false,
    })
    localStorage.removeItem('category_name')
}
   handleCatToggle(){
    this.setState({
        toggleCategory : true,
           toggleGender : false,
        toggleSize : false,
        toggleColor : false,
        toggleRange : false,
     })
     localStorage.removeItem('category_name')
    //  var elmnt = document.getElementById("collection-filter-block");
    //   elmnt.scrollTop =80;
}
handleSizeToggle(){
    this.setState({
        toggleCategory : false,
           toggleGender : false,
        toggleBrand : false,
        toggleSize : true,
        toggleColor : false,
        toggleRange : false,
     })
     localStorage.removeItem('category_name')
    //  var elmnt = document.getElementById("collection-filter-block");
    //   elmnt.scrollTop =180;
}
handleColorToggle(){
    this.setState({
        toggleCategory : false,
           toggleGender : false,
        toggleBrand : false,
        toggleSize : false,
        toggleColor : true,
        toggleRange : false,
     })
     localStorage.removeItem('category_name')
    //   var elmnt = document.getElementById("collection-filter-block");
    //   elmnt.scrollTop =230;
}
handleRangeToggle(){
    this.setState({
        toggleCategory : false,
           toggleGender : false,
        toggleBrand : false,
        toggleSize : false,
        toggleColor : false,
        toggleRange : true,
     })
     localStorage.removeItem('category_name')
     var elmnt = document.getElementById("collection-filter-block");
     elmnt.scrollTop =300;
}
clickBrandHandle = (event) => {
    const { selectedBrands } = this.state;
    const selected = [...selectedBrands];
    const {tenant_name} = this.props 

    this.props.brands.forEach(brand => {

        if (brand.BRD_CD === event.target.id) {

            const index = selected.indexOf(event.target.id);

            if (!selected.includes(event.target.id)) {

                // Allow only one selection
                if (selected.length >= 1) {
                    selected.splice(0, selected.length);
                }

                selected.push(event.target.id);

                this.setState(
                    {
                        selectedBrands: selected,
                        selectedCategories: [],
                        selectedSizes: [],
                        selectedColors: [],
                        value: { min: 0, max: 999999 },
                        brandError: ""
                    },
                    () => {

                        const options = {
                            connection_id: this.props.connection_id,
                            category_id: "",
                            gender_id: this.state.selectedGenders,
                            brand_code: this.state.selectedBrands[0],
                            category_level_1: null,
                            category_level_2: null,
                            category_level_3: null,
                            category_level_4: null,
                            category_level_5: null,
                            tenant_name,


                        };

                        this.props.getAllFilters(options);

                    }
                );

            } else {

                // Uncheck brand
                selected.splice(index, 1);

                this.setState(
                    {
                        selectedBrands: selected,
                        selectedCategories: [],
                        selectedSizes: [],
                        selectedColors: [],
                        value: { min: 0, max: 999999 },
                        brandError: ""
                    },
                    () => {

                        const options = {
                            connection_id: this.props.connection_id,
                            category_id: "",
                            gender_id: this.state.selectedGenders,
                            brand_code: this.state.selectedBrands[0],
                            category_level_1: null,
                            category_level_2: null,
                            category_level_3: null,
                            category_level_4: null,
                            category_level_5: null,
                            tenant_name
                        };

                        this.props.getAllFilters(options);

                      
                    }
                );

            }
        }

    });
};
clickGenderHandle = (event) => {

    const { selectedGenders } = this.state;
    const selected = [...selectedGenders];

    this.props.genders.forEach(gender => {

        if (gender.GEN_GENDER_CD === event.target.id) {

            const index = selected.indexOf(event.target.id);

            if (!selected.includes(event.target.id)) {

//               if (selected.length >= 3) {

//     this.setState({
//         genderError: "Maximum 3 genders can be selected."
//     });

//     setTimeout(() => {
//         this.setState({
//             genderError: ""
//         });
//     }, 2000);

//     return;
// }

                selected.push(event.target.id);

            } else {

                selected.splice(index, 1);

            }

            this.setState(
                { selectedGenders: selected },
                () => {

                    // const options = {
                    //     connection_id: this.props.connection_id,
                    //     category_id: this.state.selectedCategories.toString(),
                    //     gender_id: this.state.selectedGenders,
                    //     brand_code : this.state.selectedBrands,
                    //     category_level_1: null,
                    //     category_level_2: null,
                    //     category_level_3: null,
                    //     category_level_4: null,
                    //     category_level_5: null,
                    // };

                    // this.setState({
                    //     selectedCategories: [],
                    //     selectedBrands: [],
                    //     selectedColors: [],
                    //     selectedSizes: [],
                    //     value: { min: 0, max: 999999 },
                    // });

                   // this.props.getAllFilters(options);
                }
            );
        }
    });
};
clickColourHandle = (event) => {
    // event.preventDefault();
    const selected = this.state.selectedColors;
    this.props.colours.map(color => {
        if (color.SKU_VARIANT1_VALCD === event.target.id) {
            var index = selected.indexOf(event.target.id);
            if (!selected.includes(event.target.id)) {
                selected.push(event.target.id)
            }
            else
                selected.splice(index, 1);
            this.setState({ selectedColors: selected },
                () => {
                    // Directly call filter api
                //    this.props.sideBarOption !== 'No' && 
                //    this.props.handleApplyFilters(this.state)
                })
        }
        else return null
    })
}
clicksizeHandle = (event) => {
    const selected = this.state.selectedSizes;
    this.props.sizes.map(size => {
        if (size.SKU_VARIANT2_VALCD === event.target.id) {
            var index = selected.indexOf(event.target.id);
            if (!selected.includes(event.target.id)) {
                selected.push(event.target.id)
            }
            else
                selected.splice(index, 1);
            this.setState({ selectedSizes: selected },
                () => {
                    // Directly call filter api
                    // this.props.sideBarOption !== 'No' &&
                    // this.props.handleApplyFilters(this.state)
                })
        }
        else return null
    })
}
clickPriceRangeHandle = (e) => {
    // Price range filter
   //this.props.handleApplyFilters(this.state)
}
clickCatHandle = (event) => {
    const { selectedCategories } = this.state;
    const selected = [...selectedCategories];
    const id = parseInt(event.target.id);
    const {tenant_name} = this.props;

    this.props.categories.forEach(category => {

        if (category.MHM_HNODE === id) {

            const index = selected.indexOf(id);

            if (!selected.includes(id)) {

                // if (selected.length >= 3) {

                //     this.setState({
                //         categoryError: "Maximum 3 categories can be selected."
                //     });

                //     setTimeout(() => {
                //         this.setState({
                //             categoryError: ""
                //         });
                //     }, 2000);

                //     return;
                // }
                  if (selected.length >= 1) {
                    selected.splice(0, selected.length);
                }

                selected.push(id);

                this.setState(
                    {
                        selectedCategories: selected,
                        categoryError: ""
                    },
                    () => {

                        const options = {
                            connection_id: this.props.connection_id,
                            category_id: this.state.selectedCategories.toString(),
                            gender_id: this.state.selectedGenders,
                            brand_code: this.state.selectedBrands[0],
                            category_level_1: null,
                            category_level_2: null,
                            category_level_3: null,
                            category_level_4: null,
                            category_level_5: null,
                            tenant_name
                        };

                        this.props.getAllFilters(options);

                      
                    }
                );

            } else {

                selected.splice(index, 1);

                this.setState(
                    {
                        selectedCategories: selected,
                        categoryError: ""
                    },
                    () => {

                        const options = {
                            connection_id: this.props.connection_id,
                            category_id: this.state.selectedCategories.toString(),
                            brand_code: this.state.selectedBrands[0],
                            gender_id: this.state.selectedGenders,
                            category_level_1: null,
                            category_level_2: null,
                            category_level_3: null,
                            category_level_4: null,
                            category_level_5: null,
                            tenant_name
                        };

                        this.props.getAllFilters(options);

                    
                    }
                );

            }
        }
    });
};
 getCSAProducts = async (e) => {
    const { filterStoreFlag, selectedBrands, selectedColors, selectedSizes,selectedCategories,selectedGenders  } = this.state;
    const { connection_id, getCSAProductList, success, sendCsaProductSearchValue } = this.props;
if (
    filterStoreFlag &&
    // selectedGenders.length > 0 &&
    selectedCategories.length > 0 &&
    selectedBrands.length > 0
) {
    let options = {
         "connection_id": connection_id,
         "product_id": null,
         "sku_id":null,
         "barcode":null,
         "store_flag":filterStoreFlag,
         "size_id":  this.state.selectedSizes,
         "color_id":  this.state.selectedColors,
         "brand_code":this.state.selectedBrands,
         "category_id":this.state.selectedCategories,
         "gender_id":this.state.selectedGenders,
         "new_arrivals":"",
         "price_start_range":this.state.value.min,
         "price_end_range":this.state.value.max,
        "page":1
         }
         localStorage.setItem('optionValue',JSON.stringify(options))
 await  getCSAProductList(options);
        this.props.history.push('/csa-products') 
        }
     else{
         if(this.validator.message.length > 1) {
            let errorMessage = "";

if (
    // selectedGenders.length === 0 &&
    selectedCategories.length === 0 &&
    selectedBrands.length === 0
) {
    errorMessage = "Brand and Category filters are required.";
}
// else if (selectedGenders.length === 0) {
//     errorMessage = "Gender filter is required.";
// }
else if (selectedBrands.length === 0) {
    errorMessage = "Brand filter is required.";
}
else if (selectedCategories.length === 0) {
    errorMessage = "Category filter is required.";
}

document.getElementById('filter_error_message').innerHTML = errorMessage;
document.getElementById('filter_error_message').style.color = 'red';
document.getElementById('filter_error_message').style.textAlign = 'center';
document.getElementById('filter_error_message').style.paddingBottom = '15px';
            
             this.forceUpdate();   
         }
     }
}
handleReset=()=>{
    this.setState({
        selectedBrands:[],
        selectedCategories:[],
        selectedColors:[],
        selectedGenders:[],
        selectedSizes:[]
    })
}
    render(){
        const { filterLoader,brandLoading,brands,sizes,colours,ranges,getAllSearchFilters,categoriesLoading, loading, genders, genderLoading, categories, rangeLoading, colorLoading, sizesLoading, sideBarOption } = this.props
        const { selectedBrands, selectedGenders, selectedColors, selectedSizes,selectedCategories } = this.state
         const cat = [
         ]
        return (
            <Menu Overlay onStateChange={this.state.matches ? mobileToggleMenu : toggleMenu} right >
               <div className={"collection-filter-block"} id='collection-filter-block' style={window.innerWidth < 789 ? {height:380}:{height:330}}>
               
                           <SlideToggle
                            collapsed={true}
                        >
                            {({toggle, setCollapsibleElement }) => (
                                <div 
                                className={ "collection-collapse-block" } 
                               // className="collection-collapse-block"
                                 onClick={()=>this.handleToggle()}>
                                    <h3 className="collapse-block-title" onClick={toggle}><b>*</b>brand{selectedBrands && selectedBrands.length > 0 ? `(${selectedBrands.length})` : ""}</h3>
                                    <div className="collection-collapse-block-content" ref={setCollapsibleElement}>
                                        <div className="collection-brand-filter">
                                        <table className="check-tab">
                                            {brandLoading ? <div className="loading-cls"></div> :
                                               brands && brands.map((brand, index) => {
                                                    return (
                                                        this.state.toggleBrand &&  <div className="custom-control custom-checkbox collection-filter-checkbox" key={index}>
                                                                   <label  htmlFor={brand.BRD_CD} onChange={(e)=>this.clickBrandHandle(e)}>
                                                                   <tr><td> <input className="checkbox_animated" type="checkbox" id={brand.BRD_CD} name={brand.BRD_CD}
                                                                       checked={selectedBrands.includes(brand.BRD_CD) ? true : false} 
                                                                    /></td><td>
                                                                    {/* checked={selectedBrands === brand.BRD_CD ? true : false} /> */}
                                                                   <p style={{marginBottom:0}}> {brand.BRD_NAME}</p></td></tr>
                                                                </label> 
                                                        </div>
                                                        )
                                                })}
                                        </table></div>
                                    </div>
                                </div>
                            )}
                        </SlideToggle>
                        {this.state.brandError && (
    <small className="text-danger">
        {this.state.brandError}
    </small>
)}
               <SlideToggle
                            collapsed={true}
                        >
                            {({toggle, setCollapsibleElement }) => (
                                <div
                               className={
    selectedBrands.length > 0
        ? "collection-collapse-block"
        : "disabledFilter collection-collapse-block"
}
                                
                                // className="collection-collapse-block"
                                 onClick={()=>this.handleCatToggle()}>
                                    <h3 className="collapse-block-title" onClick={toggle}><b>*</b>Category{selectedCategories && selectedCategories.length > 0 ? `(${selectedCategories.length})` : ""}</h3>
                                    <div className="collection-collapse-block-content" ref={setCollapsibleElement}>
                                        <div className="collection-brand-filter">
                                            <table className="check-tab">
                                            {categoriesLoading ? <div className="loading-cls"></div> :
                                               categories && categories.map((category, index) => {
                                                    return (
                                                        this.state.toggleCategory &&  <div className="custom-control custom-checkbox collection-filter-checkbox" key={index}>
                                                                   <label  htmlFor={category.MHM_HNODE} onChange={(e)=>this.clickCatHandle(e)}>
                                                                   <tr><td>
                                                                    <input className="checkbox_animated" type="checkbox" id={category.MHM_HNODE} name={category.MHM_HNODE}
                                                                       checked={selectedCategories.includes(category.MHM_HNODE) ? true : false} 
                                                                    /></td><td>
                                                                    {/* checked={selectedCategories === brand.MHM_HNODE ? true : false} /> */}
                                                                    <p style={{marginBottom:0}}>{category.MHM_HNODE_LDESC}</p>
                                                                    </td></tr>
                                                                </label> 
                                                        </div>
                                                        )
                                                })}
                                                </table>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </SlideToggle>
                             {this.state.categoryError && (
    <small className="text-danger">
        {this.state.categoryError}
    </small>
)}
<SlideToggle
                            collapsed={true}
                        >
                            {({toggle, setCollapsibleElement }) => (
                                <div  className={selectedCategories.length > 0 ? "collection-collapse-block" : "disabledFilter collection-collapse-block" } onClick={()=>this.handleGenderToggle()}>
                                    <h3 className="collapse-block-title" onClick={toggle}>gender{selectedGenders && selectedGenders.length > 0 ? `(${selectedGenders.length})` : ""}</h3>
                                    <div className="collection-collapse-block-content" ref={setCollapsibleElement}>
                                        <div className="collection-brand-filter">
                                        <table className="check-tab">
                                            {genderLoading ? <div className="loading-cls"></div> :
                                               genders && genders.map((gender, index) => {
                                                    return (
                                                        this.state.toggleGender &&  <div className="custom-control custom-checkbox collection-filter-checkbox" key={index}>
                                                                   <label  htmlFor={gender.GEN_GENDER_CD} onChange={(e)=>this.clickGenderHandle(e)}>
                                                                   <tr><td> <input className="checkbox_animated" type="checkbox" id={gender.GEN_GENDER_CD} name={gender.GEN_GENDER_CD}
                                                                       checked={selectedGenders.includes(gender.GEN_GENDER_CD) ? true : false} 
                                                                    /></td><td>
                                                                    {/* checked={selectedGenders === gender.GEN_GENDER_CD ? true : false} /> */}
                                                                   <p style={{marginBottom:0}}> {gender.GEN_GENDER_NAME}</p></td></tr>
                                                                </label> 
                                                        </div>
                                                        )
                                                })}
                                        </table></div>
                                    </div>
                                </div>
                            )}
                        </SlideToggle>
                        {/* {this.state.genderError && (
    <small className="text-danger">
        {this.state.genderError}
    </small>
)} */}
                        <SlideToggle
                            // collapsed={sideBarOption === 'No' ? true : false}
                            collapsed={true} 
                        >
                            {({ toggle, setCollapsibleElement }) => (
                                <div 
                                className={selectedCategories.length > 0 ? "collection-collapse-block" : "disabledFilter collection-collapse-block" } 
                                //className="collection-collapse-block" 
                                onClick={()=>this.handleSizeToggle()}>
                                    <h3 className="collapse-block-title" onClick={toggle}>Size {selectedSizes.length > 0 ? `(${selectedSizes.length})` : ""}</h3>
                                    <div className="collection-collapse-block-content" ref={setCollapsibleElement}>
                                        <div className="collection-brand-filter">
                                            <table className="check-tab" >
                                            {sizesLoading ? <div className="loading-cls"></div> :
                                              sizes &&  sizes.map((size, index) => {
                                                    return (
                                                        this.state.toggleSize && <div className="custom-control custom-checkbox collection-filter-checkbox" key={index}>
                                                            <label htmlFor={size.SKU_VARIANT2_VALCD} onChange={(e) => this.clicksizeHandle(e)}>
                                                               <tr><td> <input className="checkbox_animated" type="checkbox" id={size.SKU_VARIANT2_VALCD} name={size.SKU_VARIANT2_VALUE_DESC}
                                                                    checked={selectedSizes.includes(size.SKU_VARIANT2_VALCD) ? true : false}
                                                                /></td><td>
                                                                <p style={{marginBottom:0}}>{size.SKU_VARIANT2_VALUE_DESC}</p></td></tr>
                                                            </label>
                                                        </div>
                                                    )
                                                })}
                                                </table>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </SlideToggle>
                        <SlideToggle
                            collapsed={true}
                        >
                            {({ toggle, setCollapsibleElement }) => (
                                <div 
                                //className="collection-collapse-block"
                                className={selectedCategories.length > 0 ? "collection-collapse-block" : "disabledFilter collection-collapse-block" } 
                                onClick={()=>this.handleColorToggle()}>
                                    <h3 className="collapse-block-title" onClick={toggle}>Color {selectedColors.length > 0 ? `(${selectedColors.length})` : ""}</h3>
                                    <div className="collection-collapse-block-content" ref={setCollapsibleElement}>
                                        <div className="collection-brand-filter">
                                            <table className="check-tab">
                                            {colorLoading ? <div className="loading-cls"></div> :
                                              colours &&  colours.map((colour, index) => {
                                                    return (
                                                        this.state.toggleColor &&  <div className="custom-control custom-checkbox collection-filter-checkbox" key={index}>
                                                            <label htmlFor={colour.SKU_VARIANT1_VALCD} onChange={(e) => this.clickColourHandle(e)}>
                                                                <tr><td><input className="checkbox_animated" type="checkbox" id={colour.SKU_VARIANT1_VALCD} name={colour.SKU_VARIANT1_VALUE_DESC}
                                                                    checked={selectedColors.includes(colour.SKU_VARIANT1_VALCD) ? true : false}
                                                                /></td><td>
                                                                <p style={{marginBottom:0}}>{colour.SKU_VARIANT1_VALUE_DESC}</p>
                                                                </td></tr></label>
                                                        </div>
                                                    )
                                                })}
                                                </table>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </SlideToggle>
                        <SlideToggle
                             onExpanded={() => {
                            //     if (!!ranges && ranges.length <= 0) {
                            //         this.onRangeToggle()
                            //     }
                           // collapsed=true
                             }}
                             onClick={console.log()}
                            collapsed={true}
                        >
                            {({ toggle, setCollapsibleElement }) => (
                                // <div className={selectedBrands === "" ? 'disabledFilter collection-collapse-block': 'collection-collapse-block'}>
                                <div 
                                className={selectedCategories.length > 0 ? "collection-collapse-block" : "disabledFilter collection-collapse-block" } 
                                //className="collection-collapse-block"
                                 onClick={()=>this.handleRangeToggle()}>
                                    <h3 className="collapse-block-title" onClick={toggle}>Price Range</h3>
                                    <div className="collection-collapse-block-content block-price-content" ref={setCollapsibleElement}>
                                    {ranges && Object.keys(ranges).length > 0 ?  
                                        <div className="collection-brand-filter">
                                            {rangeLoading ? <div className="loading-cls"></div> : 
                                           this.state.toggleRange && <div className="custom-control custom-checkbox collection-filter-checkbox">
                                                   {/* {ranges.MAX_LOT_PRICE >  ranges.MIN_LOT_PRICE ?  */}
                                                   <InputRange
          maxValue={parseInt(ranges.MAX_LOT_PRICE) || null}
          minValue={parseInt(ranges.MIN_LOT_PRICE) || null}
          value={this.state.value}
          onChange={value => this.setState({ value })}
          onChangeComplete={(e)=>this.clickPriceRangeHandle(e)} /> 
          {/* :''} */}
                                                </div>
                                            }
                                        </div>
                                         : '' }
                                    </div>
                                </div>
                            )}
                        </SlideToggle>
                        </div>
                        <div style={{}}>
                        <div className="row">
                        <div className="col">
<div style={{ padding: "10px 0px" }}  >
    <label htmlFor="csaStoreFilter" onClick={() => { this.setState({ filterStoreFlag: 'AL' }) }}>
        <input className="radio_animated" type="radio" id="csaStoreFilter" name="csaStoreFilter" checked={this.state.filterStoreFlag ==='AL'} />
        <span style={{color:'black'}}>All Store</span>
    </label>
</div>
</div>
<div className="col">
<div style={{ padding: "10px 0px" }}  >
    <label htmlFor="csaStoreFilter" onClick={() => { this.setState({ filterStoreFlag: 'TS' }) }}>
        <input className="radio_animated" type="radio" id="csaStoreFilter" name="csaStoreFilter" checked={this.state.filterStoreFlag ==='TS'}/>
        <span style={{color:'black'}}>This Store</span>
    </label>
</div>
{this.validator.message('Store Flag', this.state.filterStoreFlag, 'required')}
</div>
                        </div>
                        <div id='filter_error_message'></div>
                        <div className="row size-box" style={{ paddingBottom: 100,textAlign:'center'}}>
                                          <div className="col"><button className="btn btn-solid " onClick={()=>this.handleReset()}>reset</button></div>   <div className="col">
                                               <button className="btn btn-solid " type="submit" onClick={(e) => this.getCSAProducts(e)} disabled={this.props.filterLoader}>{this.props.filterLoader ?  'loading...': 'Go'}</button></div>
                                    </div>
                                    </div>
            </Menu>
          );
    }
}
const mapStateToProps = state => ({
    brands: state.filters.brand.data,
    brandLoading: state.filters.brand.loading,
    genders: state.filters.gender.data ||[],
    genderLoading: state.filters.gender.loading,
    ranges: state.filters.range.data,
    rangeLoading: state.filters.range.loading,
    colours: state.filters.colour.data || [],
    colourLoading: state.filters.colour.loading,
    sizes: state.filters.size.data || [],
    sizesLoading: state.filters.size.loading,
    categories: state.filters.categories.data|| [],
    categoriesLoading: state.filters.categories.loading,
    csaProducts : state.csa.csaProducts,
    filters: state.filters,
    filterLoader : state.csa.loading,
    connection_id: state.tenant.connection_id,
    loading: state.filters.loading,
     tenant_name: state.tenant.store_details.tenant_name || "",
})
const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        { getCSAProductList, sendCsaProductSearchValue,getAllFilters },
        dispatch
    );
export default connect(mapStateToProps,mapDispatchToProps)(withRouter(BurgerMenu))
